import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'

interface Props {
  title: ReactNode
  className?: string
  items?: null | ReadonlyArray<{
    title: ReactNode
    description: ReactNode
  } | null>
}

export const LandingFeatures: FC<Props> = ({ title, className, items }) => {
  return (
    <div className={classNames('py-14', className)}>
      <h2 className="text-2xl font-bold mb-6">{title}</h2>

      <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items?.map((item, index) => (
          <li key={index}>
            <h4 className="text-lg mb-2">{item?.title}</h4>

            <div
              className="text-slate-500"
              dangerouslySetInnerHTML={{ __html: item?.description || '' }}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
